import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';

interface PerformanceRecord {
  c1S: string;
  c4: string; // 날짜 (YYYY-MM-DD)
  c26: number;
}

interface Props {
  records: PerformanceRecord[];
  colors: string[];
}

const C1SMonthlyLineChart: React.FC<Props> = ({ records, colors }) => {
  // 월별 소분류별 집계
  const monthSet = new Set<string>();
  const c1SSet = new Set<string>();
  const dataMap: Record<string, Record<string, number>> = {};
  records.forEach(rec => {
    if (!rec.c1S || !rec.c4) return;
    const month = rec.c4.slice(0, 7); // YYYY-MM
    monthSet.add(month);
    c1SSet.add(rec.c1S);
    if (!dataMap[rec.c1S]) dataMap[rec.c1S] = {};
    dataMap[rec.c1S][month] = (dataMap[rec.c1S][month] || 0) + rec.c26;
  });
  const months = Array.from(monthSet).sort();
  const c1SList = Array.from(c1SSet);

  const datasets = c1SList.map((c1S, idx) => ({
    label: c1S,
    data: months.map(month => dataMap[c1S][month] || 0),
    borderColor: colors[idx % colors.length],
    backgroundColor: colors[idx % colors.length],
    fill: false,
    tension: 0.2,
    pointRadius: 2,
    pointHoverRadius: 5,
  }));

  return (
    <div className="chart line-chart">
      <Line
        data={{
          labels: months,
          datasets,
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true },
            title: { display: false },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.parsed.y;
                  return `${context.dataset.label}: ${value.toLocaleString()}원`;
                }
              }
            }
          },
          scales: {
            y: {
              title: { display: true, text: '매출액' },
              ticks: {
                callback: function(value) {
                  return value.toLocaleString();
                }
              }
            },
            x: {
              title: { display: true, text: '월' },
            }
          }
        }}
        height={400}
      />
    </div>
  );
};

export default C1SMonthlyLineChart; 